import { Component, OnInit } from '@angular/core';
import { ConfigService } from '../../../config/config.service';
import { Router } from '@angular/router';
import { IntegrationPlatformType } from '../../../integrations/models/integration.model';
import { IntegrationsService } from '../../../integrations/integration.service';
import { AccountService, FullConfig } from '../../../shared/services/account.service';
import { filter, flatMap } from 'rxjs/operators';
import WidgetService from '../../../../../old-crazy-web-frontend/src/app/utils/widget.service';
import AuthService from '../../../../../old-crazy-web-frontend/src/app/auth/auth.service';
import { merge } from 'rxjs';

@Component({
  selector: 'cc-channels-left-menu',
  templateUrl: './channels-left-menu.component.html',
  styleUrls: ['./channels-left-menu.component.scss']
})
export class ChannelsLeftMenuComponent implements OnInit {
  public smsEnabled = false;
  private widgetService: WidgetService;
  private authService: AuthService;

  constructor(
    private configService: ConfigService,
    private router: Router,
    private integrationService: IntegrationsService,
    private accountService: AccountService
  ) {
    this.widgetService = configService.getValue('WidgetService');
    this.authService = configService.getValue('AuthService');
  }

  ngOnInit() {
    merge(this.accountService.accountConfiguredData$, this.accountService.configChanged)
      .pipe(
        filter((config: FullConfig | boolean) => (typeof config === 'boolean' ? config : config.data)),
        flatMap(() => this.integrationService.checkIntegrationStatus(IntegrationPlatformType.TWO_WAY))
      )
      .subscribe(status => {
        this.smsEnabled = status.availableToInstall;
      });
  }

  isSmsLink() {
    return this.router.url.includes('two_way');
  }

  isWebCallLink() {
    return this.router.url.includes('web_call');
  }

  isRouteActive(route) {
    return this.router.isActive(route, false);
  }

  isChannelsClientType() {
    return this.authService.isChannelsClientType();
  }

  isShoperConnectClientType() {
    return this.authService.isShoperConnectClientType();
  }

  onGetWidget() {
    this.widgetService.getWidget();
  }
}
